import Axios from "axios";

class OperacaoMoedaDataService {
  catalogoRecontagem() {
    return Axios.get("operacaoMoeda/recontagem");
  }

  getAll() {
    return Axios.get("operacaoMoeda");
  }

  getAllActive(params = {}) {
    return Axios.get("operacaoMoeda/active", { params });
  }

  getPage(params) {
    return Axios.get("operacaoMoeda/page", { params });
  }

  migrarVinculosTipoMoeda() {
    return Axios.post("operacaoMoeda/migrar-vinculos-tipo-moeda");
  }

  create(params) {
    return Axios.post("operacaoMoeda", params);
  }

  update(params) {
    return Axios.put(`operacaoMoeda/${params.id}`, params);
  }

  find(id) {
    return Axios.get(`operacaoMoeda/${id}`);
  }

  delete(id) {
    return Axios.delete(`operacaoMoeda/${id}`);
  }
}

export default new OperacaoMoedaDataService();
